import React from 'react';
import Header from '../../components/doctors/partials/Header';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import PrescriptionSetings from '../../components/doctors/prescriptionSettings';
import PrintSettings from '../../components/doctors/printSettings';
import PresetSettings from '../../components/doctors/presetSettings';
import AssistantSettings from '../../components/doctors/assistantSettings';
import ItemElementNotes from '../../components/doctors/itemElementNotes';
import TopLeftMenu from '../../components/doctors/partials/topLeftMenu';

function Settings() {
  return (
    <div>
      <Header />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-md-12 sticky-header shadow header-sticky-second">
            <TopLeftMenu />
          </div>
        </div>
        <Row className="rx-body">
          <div className="col-xl-12 col-md-12 col-lg-12">
            <div className="card shadow mb-4">
              <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 className="m-0 font-weight-bold text-primary">Settings</h6>
              </div>
              <div className="card-body appointment-card-body pt-3 pl-1">
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey="preset-settings"
                >
                  <Row>
                    <Col sm={2}>
                      <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                          <Nav.Link
                            eventKey="preset-settings"
                            className="black"
                          >
                            Priority Control
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="prescription-settings">
                            Prescription Config
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="print-settings">
                            Print Config
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="assistant-settings">
                            Assistant Control
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="item-element-notes">
                            Item Notes
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={10}>
                      <Tab.Content>
                        <Tab.Pane eventKey="preset-settings">
                          <PresetSettings />
                        </Tab.Pane>
                        <Tab.Pane eventKey="prescription-settings">
                          <PrescriptionSetings />
                        </Tab.Pane>
                        <Tab.Pane eventKey="print-settings">
                          <PrintSettings />
                        </Tab.Pane>
                        <Tab.Pane eventKey="assistant-settings">
                          <AssistantSettings />
                        </Tab.Pane>
                        <Tab.Pane eventKey="item-element-notes">
                          <ItemElementNotes />
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>

                {/* <Tabs
                  defaultActiveKey="preset-settings"
                  id="uncontrolled-tab-example"
                  className="mb-3"
                >
                  <Tab eventKey="preset-settings" title="Preset Settings">
                    <PresetSettings />
                  </Tab>
                  <Tab
                    eventKey="prescription-settings"
                    title="Prescription Settings"
                  >
                    <PrescriptionSetings />
                  </Tab>
                  <Tab eventKey="print-settings" title="Print Settings">
                    <PrintSettings />
                  </Tab>
                  <Tab eventKey="assistant-settings" title="Assistant Settings">
                    <AssistantSettings />
                  </Tab>
                </Tabs> */}
              </div>
            </div>
          </div>
        </Row>
      </div>
    </div>
  );
}

export default Settings;
